import Script from "platform/network/script/Script";
import {Logger} from "platform/logger/Logger";
import {DoLinkLineChatAccount} from "core/redux/settings/SettingsReduxActions";
import Platform from "platform/Platform";
import {HideLoader, SetLoader} from "platform/redux/core/CoreActions";
import {LoaderType} from "platform/enum/LoaderType";
import WebUtil from "platform/util/WebUtil";
import {LanguageUtil} from "platform/util/LanguageUtil";
import {AuthState} from "core/state/AuthState";
import {ServiceType} from "enum/ServiceType";
import {SetTradingModal} from "core/redux/app/AppReduxActions";
import TradingModalType from "enum/TradingModalType";

const LiffState: string = WebUtil.urlParam("liff.state");

export class LineChat {

    private static _logger: Logger = Logger.Of("LineChat");

    public static Login = (liffId: string): void => {
        Platform.dispatch(SetLoader({loaderType: LoaderType.FullScreen}));
        LineChat.Inject(liffId, () => {
            Platform.dispatch(HideLoader({}));
            const authState: AuthState = Platform.state(ServiceType.Auth);
            window.liff.login({redirectUri: WebUtil.addGetParams(`${window.location.origin}/symbols`, {
                    lang: LanguageUtil.languageCode(),
                    token: authState.token,
                    liffId
                })});
        }, () => Platform.dispatch(HideLoader({})));
    }

    public static LinkIfNeed = (): void => {
        if (LiffState) {
            const decodedLiffState: string = decodeURIComponent(LiffState);
            const liffid: string = WebUtil.urlParam("liffId", decodedLiffState);
            LineChat.Inject(liffid, async () => {

                try {
                    const profile = await window.liff.getProfile();
                    LineChat._logger.info(`LIFF user ID: ${profile.userId}`);
                    if (profile.userId) {
                        Platform.dispatch(DoLinkLineChatAccount({lineUserId: profile.userId}));
                    }
                } catch (e) {
                    Platform.dispatch(HideLoader({}));
                    LineChat._logger.warn("Failed fetch LIFF profile", e);
                }
            });
        }
    }

    private static Inject = (liffId: string, callback: () => void, onerror?: () => void): void => {
        Script.injectScript("https://static.line-scdn.net/liff/edge/2/sdk.js", "line-chat-sdk", async () => {
            try {
                await window.liff.init({ liffId });
                LineChat._logger.info("LIFF initialized");

                callback();
            } catch (e) {
                LineChat._logger.warn("Failed init LIFF", e);
                onerror?.();
            }
        }, onerror);
    }
}
